import PrivacyNoticeLink from './PrivacyNoticeLink';

export const SCREENING_PRIVACY_PATH = '/privacy/screening';
export const SCREENING_PRIVACY_LABEL = 'How we use your answers';

// The thank-you after a pre-screen is sent (Contact Hub 3, Task 12). Also shown when a link is opened again after
// the answers were sent. Never shows a name, panel number or study.
function ScreeningDone() {
  return (
    <div className="thank-you-container">
      <div className="thank-you-icon">&#10003;</div>
      <h1>All done</h1>
      <p>Thank you so much! We've got your answers, and someone from our team will be in touch soon.</p>
      <PrivacyNoticeLink href={SCREENING_PRIVACY_PATH} label={SCREENING_PRIVACY_LABEL} />
    </div>
  );
}

export default ScreeningDone;
